import React from 'react';
import { CourseSidebar } from './CourseSidebar';
import { CourseProgressProvider } from '../../lib/course-progress-context';
import { cn } from '../../lib/utils';

export const CourseLayout = ({ 
  children, 
  className, 
  courseStructure, 
  courseId,
  isPurchased = true // Par défaut, considérer que le cours est accessible
}) => {
  return (
    <CourseProgressProvider>
      <div className="min-h-screen">
        <CourseSidebar courseStructure={courseStructure} courseId={courseId} isPurchased={isPurchased} />
        <div className={cn("ml-4 md:ml-[270px] p-4 md:p-6 md:pr-8 overflow-auto transition-all", className)}>
          <div className="container max-w-8xl mx-auto px-4 w-full">
            {children}
          </div>
        </div>
      </div>
    </CourseProgressProvider>
  );
}; 